import { HttpClient } from '@shared/adapters/HttpClient';

export interface CourierOption {
    id: string;
    name: string;
}

export class CouriersApiAdapter {
    constructor(private httpClient: HttpClient) { }

    async getAll(): Promise<CourierOption[]> {
        const raw = await this.httpClient.get<any>('/couriers');
        const list = Array.isArray(raw) ? raw : (raw.data ?? []);
        return list.map((courier: any) => ({
            id: String(courier.id),
            name: courier.name,
        }));
    }
}

